import { getAppConfig } from './config';

const appConfig = getAppConfig();

export const sessionTokenViaCookieOption =
  appConfig.environment === 'development' ? { secure: false } : false;
